import parsePhoneNumber from "libphonenumber-js";

export function formatPhone(phone) {
  try {
    return parsePhoneNumber(phone, "UA").number;
  } catch (e) {
    return phone;
  }
}

export function phoneCheck(phone) {
  try {
    return parsePhoneNumber(phone, "UA").isValid();
  } catch (e) {
    return false;
  }
}

export function formatPhoneInternational(phone) {
  return parsePhoneNumber(phone).formatInternational();
}
